import React from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { CreateClub } from './CreateClubPage'

const ClubCreationPage = props => <CreateClub {...props} leadId={props.match.params.id} />

export default connect(({ session }) => ({ settings: session.settings, userDetails: session.userDetails }))(withRouter(ClubCreationPage))
